// components/const/Daily/WorkNoteSection.jsx
import { useState, useEffect, useRef } from "react";
import { getWorkDetails } from "../../../api/const";

export default function WorkNoteSection({
  todayWork,
  setTodayWork,
  tomorrowWork,
  setTomorrowWork,
  date,
  setSelectedActivities,
  selectedActivities,
}) {
  const [existing, setExisting] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // textarea DOM 참조
  const todayRef = useRef(null);
  const tomorrowRef = useRef(null);

  // textarea 높이를 내용에 맞게 자동 조절
  const autoResize = (el) => {
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${el.scrollHeight}px`;
  };

  // 저장된 상세작업 불러오기
  useEffect(() => {
    if (!date) return;
    (async () => {
      try {
        const data = await getWorkDetails(date);
        setExisting(data.results);
      } catch (err) {
        console.error("상세작업 불러오기 실패", err);
      }
    })();
  }, [date]);

  // todayWork / tomorrowWork 값이 바뀔 때마다 높이 재조정
  useEffect(() => {
    autoResize(todayRef.current);
  }, [todayWork]);

  useEffect(() => {
    autoResize(tomorrowRef.current);
  }, [tomorrowWork]);

  // 적용 버튼
  const applySelected = () => {
    const text = existing
      .filter((w) => selectedActivities.includes(w.activity))
      .map((w) => {
        if (w.content) {
          const lines = w.content.split("\n").filter((l) => l.trim() !== "");
          const bullets = lines.map((l) => `- ${l}`).join("\n");
          return `${w.activity_name}\n${bullets}`;
        } else {
          return w.activity_name;
        }
      })
      .join("\n\n");

    setTodayWork((prev) => (prev ? prev + "\n\n" + text : text));
    setIsModalOpen(false);
  };

  return (
    <div className="w-full">
      {/* 테이블 래퍼 */}
      <div className="overflow-hidden text-sm">
        {/* 확정 작업 */}
        <div className="w-full  text-sm overflow-hidden mb-4">
          {/* 제목 줄 */}
          <div className="tbl-label-bg px-2 py-1 flex justify-between items-center">
            <span className="text-body">확정 작업사항</span>
            <button
              className="btn-basic-sm"
              onClick={() => setIsModalOpen(true)}
            >
              + 상세작업
            </button>
          </div>

          {/* 내용 칸 */}
          <div className="px-3 py-3 border-r border-l border-b border-black">
            <textarea
              ref={todayRef}
              className="w-full rounded border px-2 py-1 text-sm focus:ring-2 focus:ring-indigo-400 resize-none overflow-hidden"
              placeholder="확정 작업사항 입력"
              value={todayWork}
              onChange={(e) => {
                setTodayWork(e.target.value);
                autoResize(e.target);
              }}
            />
          </div>
        </div>

        {/* 명일 작업사항 */}
        <div className="w-full text-sm overflow-hidden mb-4">
          {/* 제목 줄 */}
          <div className="tbl-label-bg px-2 py-1 flex justify-between items-center text-body-bold">
            예정 작업사항
          </div>

          {/* 내용 칸 */}
          <div className="px-3 py-3 border-r border-l border-b border-black">
            <textarea
              ref={tomorrowRef}
              className="w-full rounded border px-2 py-1 text-sm focus:ring-2 focus:ring-indigo-400 resize-none overflow-hidden"
              placeholder="예정 작업사항 입력"
              value={tomorrowWork}
              onChange={(e) => {
                setTomorrowWork(e.target.value);
                autoResize(e.target);
              }}
            />
          </div>
        </div>
      </div>

      {/* 상세작업 선택 모달 */}
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <div className="w-[600px] max-h-[80vh] overflow-y-auto rounded-xl bg-white p-6 shadow-xl">
            <h3 className="mb-4 text-lg font-semibold text-gray-800">
              상세작업 선택
            </h3>

            <div className="mb-3 rounded border border-yellow-200 bg-yellow-50 p-2 text-xs text-yellow-700">
              선택한 작업은 "확정 작업사항"에 자동 추가됩니다.
            </div>

            <div className="space-y-2">
              {existing.length ? (
                existing.map((w) => (
                  <label
                    key={w.id}
                    className="flex cursor-pointer items-start gap-3 rounded border p-2 hover:bg-gray-50"
                  >
                    <input
                      type="checkbox"
                      className="mt-1"
                      checked={selectedActivities.includes(w.activity)}
                      onChange={() =>
                        setSelectedActivities((prev) =>
                          prev.includes(w.activity)
                            ? prev.filter((id) => id !== w.activity)
                            : [...prev, w.activity]
                        )
                      }
                    />
                    <div>
                      <div className="flex items-center">
                        <span className="text-sm font-medium text-gray-800">
                          {w.activity_name}
                        </span>
                        <span className="ml-2 text-xs text-gray-500">
                          (작성자: {w.created_by_name})
                        </span>
                      </div>
                      {w.content && (
                        <span className="whitespace-pre-line text-xs text-gray-600">
                          {w.content}
                        </span>
                      )}
                    </div>
                  </label>
                ))
              ) : (
                <p className="text-sm text-gray-500">저장된 상세작업 없음</p>
              )}
            </div>

            <div className="mt-6 flex justify-end gap-3">
              <button
                className="rounded border px-4 py-2 text-sm hover:bg-gray-50"
                onClick={() => setIsModalOpen(false)}
              >
                취소
              </button>
              <button
                className="rounded bg-blue-500 px-4 py-2 text-sm text-white shadow hover:bg-blue-600"
                onClick={applySelected}
              >
                적용
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
